export default __webpack_public_path__ + "static/modal-icon-check.png";